export default {
  OK: "ОК",
  ok: "ОК",
  loginFailed: "Вход не удался, повторите попытку",
  requestFailed: "Запрос не удался, проверьте соединение с Интернетом",
  invalidLogin: "Неверное имя пользователя или пароль",
  thisFunctionExists: "Эта функция уже существует ",
  thisFunctionNotAllowDelete: "Эта функция не может быть удалена",
  thisFunctionNotExists: "Эта функция не существует ",
  targetFunctionIdRequired: "Требуется ID целевой функции",
  thisPageExists: "Эта страница уже существует ",
  thisPageNotAllowDelete: "Эту страницу нельзя удалить",
  thisRoleExists: "Эта роль уже существует ",
  thisRoleNotAllowDelete: "Требуется ID целевой роли",
  targetRoleIdRequired: "Требуется целевая роль",
  invalidParameter: "Недействительный параметр",
  systemError: "Система не может обработать ваш запрос",
  spErrorMessage: "Ошибка сообщения SP (зависит от типа ошибки)",
  actionbyRequired: "Требуется текущий пользователь",
  sessionTokenRequired: "Требуется токен сессии",
  functionIdRequired: "Требуется ID функции",
  functionNameRequired: "Требуется название функции",
  newFunctionNameRequired: "Требуется название функции",
  pageIdRequired: "Требуется ID страницы",
  newPageIdRequired: "Требуется ID страницы",
  newPageNameRequired: "Требуется название страницы",
  targetPageIdRequired: "Требуется ID целевой страницы",
  passwordRequired: "Требуется пароль",
  userNameRequired: "Требуется полное имя",
  passwordValidation: "Пароль должен содержать от 6 до 20 символов и представлять собой комбинацию цифр и букв",
  pageNumRequired: "Требуется номер страницы",
  pageSizeRequired: "Требуется размер страницы",
  roleIdRequired: "Требуется ID роли",
  oldPasswordRequired: "Требуется текущий пароль",
  userStatusRequired: "Требуется статус пользователя",
  newRoleIdRequired: "Требуется ID роли",
  newRoleNameRequired: "Требуется название роли",
  startDateIsGteEndDate: "Дата начала больше даты окончания",
  thisRoleNotExists: "Эта роль не существует",
  thisPageNotExists: "Эта роль уже существует",
  thisUserExists: "Этот пользователь уже существует",
  thisUserNotExists: "Этот пользователь не существует",
  thisUserBlackListed: "Ваша учётная запись приостановлена",
  thisUserInactive: "Ваша учётная запись отключена",
  thisUserBlocked: "Ваша учетная запись заблокирована",
  thisUserNotActive: "Ваша учётная запись отключена",
  InvalidPageFunction: "Недопустимая функция страницы",
  invalidUser: "Недопустимый пользователь!",
  invalidToken: "Недопустимая сессия",
  NoUserAccessRight: "Доступ запрещен!",
  connection: "Ошибка соединения",
  profileIdRequired: "Требуется ID профиля",
  packageIdRequired: "Требуется ID пакета",
  fullNameMinThreeChar: "Полное имя должно содержать не менее 3 символов",
  accountIdMinThreeChar: "ID акаунта должно содержать не менее 3 символов",
  searchCriteriaRequired: "Требуется параметр поиска",
  affiliateIdRequired: "Требуется ID агента",
  minDepositRequired: "Требуется мин депозит",
  bonusRateRequired: "Требуется процент бонуса",
  onlyAllowRejectDeposit: "Разрешено отклонять только тикет депозита",
  senderBankIdRequired: "Требуется ID банка отправителя",
  senderBankAccNoRequired: "требуется номер банковского счета отправителя",
  minFTDAmtNumOnly: "Мин сумма ПД принимает только цифры",
  maxFTDAmtNumOnly: "Макс сумма ПД принимает только цифры",
  crmBasicCriteriaRequired: "ID участника / контактный номер телефона / дата регистрации / требуется дата последнего входа в систему",
  verifiedDateRangeAllowThreeMonths: "Диапозон дат регистраций позволяет выбрать только до 3 месяцев",
  lastLoginDateRangeAllowThreeMonths: "Диапозон дат последней регистрации позволяет выбрать только до 3 месяцев",
  depositDateRangeAllowThreeMonths: "Диапозон дат депозита позволяет выбрать только до 3 месяцев",
  ftdDateRangeAllowThreeMonths: "Диапозон дат ПД позволяет выбрать только до 3 месяцев",
  ltdDateRangeAllowThreeMonths: "Диапозон дат последнего депозита позволяет выбрать только до 3 месяцев",
  lastLoginDateEarlierThanVerifiedDate: "Дата последнего входа раньше даты регистрации",
  depositDateEarlierThanVerifiedDate: "Дата депозита раньше даты регистрации",
  ftdDateEarlierThanVerifiedDate: "дата первого депозита раньше дата регистрации",
  ltdDateEarlierThanVerifiedDate: "дата последнего депозита раньше даты регистрации",
  ftdFromRequired: "Требуется дата от первого депозита",
  ftdToRequired: "Требуется дата до первого депозита",
  ltdFromRequired: "Требуется дата до последнего депозита",
  ltdToRequired: "Требуется дата от последнего депозита",
  failedToLaunchPaymentGateway: "не удалось запустить платежный сервис",
  enTitleRequired: "Требуется заголовок EN",
  enBodyRequired: "Требуется основной текст EN",
  enImageUrlRequired: "Требуется URL изображения EN",
  enImageUrlDesktopRequired: "Требуется URL десктопного изображения EN",
  enAltRequired: "требуется  Alt EN ",
  enHrefRequired: "Требуется Href EN",
  resubmitTicketRequired: "Требуется повторная отправка тикета",
  withtholdBonusAndAmountGreaterThanZero: "Сумма удержания бонуса и сумма удержания не могут быть больше нуля одновременно",
  maxWithdrawMultipleAndAmountGreaterThanZero: "Макс множественный вывод и макс сумма вывода не могут быть больше нуля одновременно",
  serverBusy: "Сервер сейчас занят. Пожалуйста, повторите попытку",
  isRequired: "Пожалуйста, введите {fname}",
  isMinValue: " {fname} должен содержать минимальное от {fvalue}",
  isMaxValue: " {fname}  должен быть меньше или равен {fvalue}",
  isMinLength: " {fname} должен иметь не менее {fvalue} символов",
  isMaxLength: " {fname} должен быть меньше или равен {fvalue}  символам",
  isAlpha: "{fname} принимает только буквы алфавита",
  isAlphaNum: "{fname} принимает только латинские буквы и цифры",
  isNumeric: "{fname} принимает только цифры",
  isEmail: "{fname} принимает только действительный адрес email",
  isIpAddress: "{fname} принимает только действительный IPv4 адрес",
  isSameAs: "{fname} должен быть таким же как {fname2}",
  isUrl: "{fname} принимает только URLs",
  containAlphaNum: "{fname}  должен содержать не менее одной буквы и одной цифры",
  alphaNumWithSpace: "{fname}  принимает только латинские буквы и цифры",
  isDecimal: "{fname} принимает только цифры",
  isInteger: "{fname} принимает только целые числа",
  selectOption: "Пожалуйста, выберите {fname}",
  notSameAs: "{fname} и {fname2} не могут быть одинаковыми ",
  dateRangeAllowOneMonth: "Диапазон дат позволяет выбрать только до 1 месяца",
  dateRangeAllowOneYear: "Диапазон дат позволяет выбрать только до 1 года",
  greaterThanZero: "{fname} должен быть больше нуля",
  atLeastOneAuthority: "Необходимо выбрать не менее одного полномочия",
  BLOCK: "Ваша учетная запись заблокирована",
  SUSPEND: "Ваша учетная запись приостановлена",
  CLOSE: "Ваша учетная запись закрыта",
  RESETL: "ваша учетная запись сброшена",
  atLeastOneProvider: "Необходимо выбрать не менее одного провайдера",
  failedToGetResultUrl: "Не удалось получить url результа",
  fileSizeValidation: "Слишком большой, макс допустимый размер 1 МБ",
  atLeastOnePaymentOption: "Необходимо выбрать не менее одного платежного метода",
  atLeastOnePaymentGateway: "Необходимо выбрать не менее одного платежного сервиса",
  dateRangeAllow31Days: "Диапазон дат: можно выбрать только до 31 дня",
  dateRangeAllow31Months: "Диапазон дат: можно выбрать только до 31 месяца",
  dateRangeAllow31Years: "Диапазон дат: можно выбрать только до 31 года",
  invalidCategory: "Недействительная категория",
  noChanges: "Нет изменений",
  permissionDenied: "в доступе отказано",
  referralCodeRequired: "Требуется реферальный код",
  providerDescRequired: "Требуется описание провайдера",
  marqueeContentRequired: "Требуется контент бегущей строки",
  bonusNameRequired: "Требуется название бонуса",
  baseAmountRequired: "Требуется базовая сумма",
  reviewIdRequired: "Требуется ID отзыва",
  surveyIdRequired: "Требуется ID  опроса",
  questionRequired: "Требуется вопрос",
  iframeIdRequired: "Требуется ID iframe",
  bonusAmountRequired: "Требуется сумма бонуса",
  inboxIdRequired: "Требуется ID входящего",
  exchangedAmountRequired: "Требуется сумма обмена",
  baseRateRequired: "Требуется базовый курс",
  exchangeRateRequired: "Требуется курс обмена",
  baseCurrencyRequired: "Требуется базовая валюта",
  exchangeCurrencyRequired: "Требуется валюта обмена",
  depositTypeRequired: "Требуется тип депозита",
  nbRedepositRequired: "Требуется повторный депозит Nb",
  bankOwnerRequired: "Требуется владелец банка",
  autoSenderRequired: " Требуется автоотправитель",
  isRecommendRequired: "Рекомендовано Требуется",
  recipientBankIdRequired: "Требуется ID банка отправителя",
  recipientBankAccNoRequired: "требуется номер банковского счета получателя",
  accountBalanceRequired: " Требуется баланс аккаунта",
  incomingAmountThresholdRequired: "Требуется порог входящей суммы",
  incomingFrequencyThresholdRequired: "Требуется порог частоты входящих",
  outgoingAmountThresholdRequired: "Требуется порог суммы исходящих",
  outgoingFrequencyThresholdRequired: "Требуется порог частоты исходящих",
  bankAccTypeRequired: "Требуется тип банковского счета",
  packageRequired: "Требуется пакет",
  rtpRequired: "Требуется RTP",
  domainIdRequired: "Требуется ID домена",
  buyOnBehalfRequired: "Требуется покупка от имени",
  serviceProviderRequired: " Требуется провайдер сервиса",
  serverAccountRequired: "Требуется аккаунт сервера",
  nameServerRequired: "Требуется название сервера",
  socialLinkRequired: "Требуется социальная ссылка",
  newSocialPlatformRequired: "Требуется новая социальная платформа",
  attachmentPathRequired: "Требуется указать путь к вложению",
  depositMethodRequired: "Требуется метод внесения депозита",
  depositDateRequired: "Требуется дата депозита",
  refNoRequired: "Требуется уникальный номер транзакции",
  withdrawalAmountRequired: "Требуется сумма вывода",
  targetBankAccNoRequired: "Требуется номер целевого банковского счета",
  targetBankIdRequired: "Требуется ID целевого банка",
  jsonRatingRequired: "Требуется рейтинг JSON",
  startTimeRequired: "Требуется время начала",
  accountIdRequired: "Требуется ID аккаунта",
  parentIdRequired: "Требуется родительский ID",
  amountRequired: "Требуется сумма",
  clientIpRequired: "Требуется IP клиента",
  auditByRequired: "Требуется аудит выполненный",
  systemTypeRequired: "Требуется тип системы",
  currencyRequired: "Требуется валюта",
  ipAddressRequired: "Требуется IP адрес",
  affiliateCodeRequired: "Требуется код агента",
  contactPhoneRequired: "Требуется контактный номер телефона",
  requestTypeRequired: "Требуется вид запроса",
  securityDisabledRequired: "Требуется отключить безопасность",
  gameCodeRequired: "Требуется код игры",
  seqRequired: "Требуется последовательность",
  minLimitRequired: "Требуется минимальный лимит",
  maxLimitRequired: "Требуется максимальный лимит",
  commSportsRequired: " Требуется комиссия за спорт",
  commSlotsRequired: "Требуется комиссия за слоты",
  commLivecasinoRequired: "Требуется комиссия за live казино",
  commCockfightRequired: "Требуется комиссия за петушиные бои",
  commOthersRequired: "Требуется комиссия за другое",
  settingValueRequired: "Требуется значение настройки",
  vipIdRequired: "Требуется VIP ID",
  carryOverRequired: "Требуется перенос",
  campaignIdRequired: "Требуется ID кампании",
  titleRequired: "Требуется заголовок",
  bodyRequired: "Требуется основной текст",
  itemOrderRequired: "Требуется порядок элементов",
  imageUrlRequired: "Требуется URL изображения",
  bannerIdRequired: "Требуется ID баннера",
  directionRequired: "Требуется направление",
  defaultOrderRequired: "Требуется порядок по умолчанию",
  altRequired: "Требуется альтернативный текст",
  hrefRequired: "Требуется Href",
  targetWindowRequired: "Требуется целевое окно",
  loginRequiredRequired: "Требуется авторизация",
  activeFromRequired: "Требуется период активности с",
  activeToRequired: "Требуется период активности до",
  bannerTypeRequired: "Требуется тип баннера",
  pageNameRequired: "Требуется номер страницы",
  remarkRequired: "Требуется  комментарий",
  settingKeyRequired: "Требуется ключ настройки",
  memberListRequired: "Требуется список участников",
  memberIdRequired: "Требуется ID участника",
  workingMonthRequired: "Требуется месяц работы",
  workingDateRequired: "Требуется дата работы",
  tacRequired: "Требуется правила и условия",
  paymentModeRequired: "Требуется режим оплаты",
  newPasswordRequired: "Требуется новый пароль",
  loginIdRequired: "Требуется ID входа",
  securityTagRequired: "Требуется вкладка безопасности",
  securityCodeRequired: "Требуется код безопасности",
  providerCodeRequired: "Требуется код провайдера",
  startDateRequired: "Требуется дата начала",
  endDateRequired: "Требуется дата окончания",
  searchIdRequired: "Требуется ID поиска",
  authTokenRequired: "Требуется токен авторизации",
  newStatusRequired: "Требуется новый статус",
  actionRequired: "Требуется действие",
  promotionIdRequired: "Требуется ID промоакции",
  promotionNameRequired: "Требуется название промоакции",
  rolloverRequired: "Требуется ролловер",
  criteriaRequired: "Требуются параметры",
  ticketIdRequired: "Требуется ID тикета",
  resultIdRequired: "Требуется ID результата",
  bankIdRequired: "Требуется ID банка",
  bankAccNoRequired: "Требуется номер банковского счета",
  bankAccHolderRequired: "Требуется владелец банковского счета",
  newBankIdRequired: "Требуется ID нового банка",
  newBankAccNoRequired: "Требуется номер нового банковского счета",
  newBankAccHolderRequired: "Требуется владелец нового банковского счета",
  fullNameRequired: "Требуется полное имя",
  depositAmountRequired: "Требуется сумма депозита",
  gatewayAccRequired: "Требуется учетная запись платежного сервиса",
  labelNameRequired: "Требуется название ярлыка",
  labelIdRequired: "Требуется ID ярлыка",
  bankTypeRequired: "Требуется тип банка",
  amountLimitRequired: "Требуется лимит суммы",
  currencyRateRequired: "Требуется курс валюты",
  urlRequired: "Требуется URL",
  cashRequired: "Требуется наличные",
  csRequired: "Требуется клиентская поддержка",
  vipNameRequired: "Требуется название VIP",
  campaignNameRequired: "Требуется название кампании",
  transferIdRequired: "Требуется ID перевода",
  betTimeRequired: "Требуется время ставки",
  turnoverRequired: "Требуется отыгрыш",
  payoutRequired: "Требуется выплата",
  winloseRequired: "Требуется выигрыш/проигрыш",
  rawMessageRequired: "Требуется сообщение RAW",
  authStatusRequired: "Требуется статус авторизации",
  dateRequired: "Требуется дата",
  betIdRequired: "Требуется ID ставки",
  betStatusRequired: "Требуется статус ставки",
  betAmountRequired: "Требуется сумма ставки",
  isParlayRequired: "Экспресс требуется",
  isAddonRequired: "Аддон требуется",
  withholdBonusRequired: "Требуется удержание бонуса",
  withholdAmountRequired: "Требуется сумма удержания",
  maxWithdrawAmountRequired: "Требуется максимальная сумма удержания",
  betTypeRequired: "Требуется тип ставки",
  maxWithdrawMultipleRequired: "Требуется макс множественный вывод",
  socialPlatformRequired: "Требуется социальная платформа",
  vipProviderRebateRequired: "Требуется скидка VIP провайдера",
  selfRebateRateRequired: "Требуется процент самовозврата",
  downlineRebateRateRequired: "Требуется процент скидки нижестоящей линии",
  tierIdRequired: "Требуется ID уровня",
  rebateRateRequired: "Требуется процент скидки",
  paymentGatewayRequired: "Требуется платежный сервис",
  rescueIdRequired: "Требуется ID спасения",
  rescueNameRequired: "Требуется название спасения",
  rescueCycleRequired: "Требуется цикл спасения",
  minLoseRequired: "Требуется минимальный проигрыш",
  rescueRateRequired: "Требуется курс спасения",
  maxPayoutRequired: "Требуется максимальная выплата",
  payoutMethodRequired: "Требуется метод выплаты",
  targetGroupRequired: "Требуется целевая группа",
  maintainDepositRequired: "Требуется поддерживать депозит",
  maintainTurnoverRequired: "Требуется поддерживать отыгрыш",
  depositOrTurnoverRequired: "Требуется депозит или отыгрыш",
  maintainDepositOrMaintainTurnoverRequired: "Требуется поддерживать депозит или поддерживать отыгрыш",
  vipListRequired: "Требуется список VIP",
  gameNameRequired: "Требуется название игры",
  claimTypeRequired: "Требуется запросить тип",
  operatorIdRequired: "Требуется ID оператора",
  maxBonusRequired: "Требуется макс бонус",
  endTimeRequired: "Требуется время окончания",
  mondayRequired: "Требуется понедельник",
  tuesdayRequired: "Требуется вторник",
  wednesdayRequired: "Требуется среда",
  thursdayRequired: "Требуется четверг",
  fridayRequired: "Требуется пятница",
  saturdayRequired: "Требуется суббота",
  sundayRequired: "Требуется воскресенье",
  promotionTypeRequired: "Требуется тип промоакции",
  claimLimitRequired: "Требуется заявить лимит",
  bonusRate1Required: "Требуется процент бонуса 1",
  bonusRate1To2Required: "Требуется процент бонуса от 1 до 2",
  bonusRate1To3Required: "Требуется процент бонуса от 1 до 3",
  bonusRate1To4Required: "Требуется процент бонуса от 1 до 4",
  bonusRate1To5Required: "Требуется процент бонуса от 1 до 5",
  bonusRate1To6Required: "Требуется процент бонуса от 1 до 6",
  bonusRate1To7Required: "Требуется процент бонуса от 1 до 7",
  externalIdRequired: "Требуется внешний ID ",
  opsiteRequired: "Требуется противоположный сайт",
  opsiteContentRequired: "Требуется контент противоположного сайта",
  opsiteLanguageRequired: "Требуется язык противоположного сайта",
  opsitePaymentRequired: "Требуется платеж противоположного сайта",
  opsiteProviderRequired: "Требуется провайдер противоположного сайта",
  opsiteProviderGamesRequired: "Требуется провайдер игр противоположного сайта",
  accountTypeRequired: "Требуется тип аккаунта",
  domainNameRequired: "Требуется имя домена",
  settledTimeRequired: "Требуется фиксированное время",
  validTurnoverRequired: "Требуется действительный отыгрыш",
  resultTimeRequired: "Требуется время результата",
  resultStatusRequired: "Требуется статус результата",
  secondIdRequired: "Требуется второй ID",
  domainListRequired: "Требуется список доменов",
  domainTypeRequired: "Требуется тип домена",
  moduleRequired: "Требуется модуль",
  gameIdRequired: "Требуется ID игры",
  gameDetailRequired: "Требуется подробности игры",
  bonusRate1To8Required: "Требуется процент бонуса от 1 до 8",
  bonusRate1To9Required: "Требуется процент бонуса от 1 до 9",
  bonusRate1To10Required: "Требуется процент бонуса от 1 до 10 ",
  invalidOrder: "Недействительный порядок",
  bannerNotExists: "Баннер не существует",
  invalidBannerType: "Недействительный тип баннера",
  pageNameExists: "название страницы существует ",
  pageNotExists: "Название страницы не существует",
  tacIsValid: "Одноразовый пароль действителен",
  invalidTac: "Одноразовый пароль недействителен",
  tacExpired: "Одноразовый пароль истек",
  tacNotValidate: "Одноразовый пароль не подтвержден",
  paymentModeNotExists: "Способ оплаты не существует",
  paymentOptionProviderNotExists: "Провайдер платежного метода не существует",
  ipAddressExists: "IP адрес существует",
  ticketProcessed: "Тикет обработан",
  bankAccountNotExists: "Банковский счет не существует",
  bankAccountInactive: "Банковский счет недействителен",
  bankMemberNotExists: "Банк участника не существует",
  bankMemberInactive: "Банк участника неактивен",
  affiliateExists: "Агент существует",
  contactPhoneExists: "Контактный номер существует",
  affiliateFull: "Агент заполнен",
  uplineInactive: "Вышестоящий неактивен",
  applicationProcessed: "Заявка обработана",
  tacValidated: "Правила и условия проверены",
  applicationPending: "Заявка на рассмотрении",
  favouriteGameExists: "Избранная игра существует",
  invalidLimit: "Недействительный лимит",
  settingNotSet: "Настройка не установлена",
  domainNameNotExists: "Имя домена не существует ",
  domainNameFull: "Имя домена полностью",
  domainNameNotAvailable: "Имя домена недоступно",
  domainNameExists: "Имя домена существует",
  subAccountNotExists: "Суб-аккаунт не существует ",
  settingNotExists: "Настройка не существует",
  invalidContactEmail: "Недействительный адрес email",
  accountInactive: "Аккаунт неактивен",
  campaignNotExists: "Кампания не существует ",
  paymentProviderNotExists: "Платежный провайдер не существует",
  profileInactive: "Профиль неактивный",
  minWithdrawalNotMet: "Минимальная сумма вывода не достигнута",
  invalidBankId: "Недействительный ID банка",
  bankAccountExists: "Банковский счет существует",
  bankAccountFull: "Банковский счет заполнен",
  bankAccHolderNotSame: "Владелец банковского счета не тот же самый",
  exceedMaxWithdrawal: "Превышен максимальный вывод",
  exceedWithdrawalFrequency: "Превышена частота вывода",
  invalidPackage: "Недействительный пакет",
  promotionNotAvailable: "Промоакция не доступна",
  ongoingPromotion: "Действующая промоакция",
  pendingResultInGame: "Ожидается результат в игре",
  labelNameExists: "Название ярлыка существует",
  labelNotExists: "Ярлык не существует",
  invalidFtdMin: "Недействительный минимальный первый депозит",
  invalidFtdMax: "Недействительный максимальный первый депозит",
  ftdMinGtFtdMax: "Минимум первого депозита больше максимума",
  vipFull: "VIP заполнен",
  invalidRewardType: "недействительный тип награды",
  vipExists: "VIP существует",
  vipNotExists: "VIP не существует",
  onlyOneMaxWithdrawSetting: "Разрешена только одна настройка максимального вывода",
  onlyOneWithholdSetting: "Разрешена только одна настройка удержания",
  campaignExists: "Кампания существует",
  vipProviderNotExists: "VIP провайдер не существует",
  turnoverTierExists: "Уровень отыгрышы существует",
  turnoverTierFull: "Уровень отыгрыша превышает максимальный уровень",
  turnoverTierNotExists: "Уровень отыгрышы не существует",
  invalidSettingValue: "Неверное значение настройки",
  turnoverTierNotSet: "Уровень отыгрышы не установлен",
  rebateProcessed: "Скидка обработана",
  invalidActionType: "Недействительный тип действия",
  invalidRescueCycle: "Недействительный цикл спасения",
  invalidPayoutMethod: "Недействительный метод вывода",
  invalidTargetGroup: "Недействительная целевая группа",
  rescueExists: "Спасение существует",
  rescueNotExists: "Спасение не существует",
  walletExists: "Кошелек существует",
  accountExists: "Аккаунт существует",
  activeFromGtActiveTo: "Активный с больше, чем активный по",
  accountNotExists: "ID оператора не существует",
  invalidDeposit: "Недействительный депозит",
  invalidTurnover: "Недействительный отыгрыш",
  providerCodeNotExists: "Код провайдера не существует",
  gameNameExists: "Название игры  существует",
  gameNameNotExists: "Название игры не существует",
  invalidAccountType: "Недействительный тип аккаунта",
  invalidLoginIdFormat: "Недействительный формат ID входа",
  invalidReferralCode: "Недействительный реферальный код",
  firstDepositNotMet: "Первый депозит не соотвествует",
  newbieNotMet: "Требования для новичка не выполнены ",
  claimPromoOnlyOnce: "Запросить промоакцию только один раз",
  promotionRequirementNotMet: "Требования промоакции не удовлетворены",
  withdrawalAmountLteWithholdAmount: "Сумма вывода меньше или равна сумме удержания",
  subAccountInactive: "суб-аккаунт неактивен",
  gameNotSupported: "Игра не поддерживается",
  startTimeGteEndTime: "Время начала больше или равно времени окончания",
  invalidPromotionType: "Недействительный тип промоакции",
  invalidClaimType: "Недействительный тип заявки",
  claimLimitExceeded10: "Лимит заявок превысил 10",
  verificationFailed: "Верификация не удалась",
  claimLimitReached: "Достигнут лимит заявок",
  invalidPromotion: "Недействительная промоакция",
  socialPlatformExists: "Социальная платформа существует",
  duplicateReview: "Дублировать отзыв",
  invalidSurveyId: "Недействительный ID опроса",
  accountNotBlock: "Аккаунт не заблокирован",
  walletNotExists: "Кошелек не существует",
  socialPlatformNotExists: "Социальная платформа не существует",
  socialPlatformInactive: "Социальная платформа неактивна",
  accountSocialExists: "Социальный аккаунт существует",
  invalidStatus: "Недействительный статус",
  samePassword: "Тот же пароль",
  invalidPassword: "Недействительное имя пользователя или пароль",
  secondaryAccountExists: "Существует второй аккаунт",
  invalidSecurityCode: "Недействительный код безопасности",
  accountSocialNotExists: "Социальный аккаунт не существует",
  providerInactive: "Провайдер неактивен",
  gameIdExists: "ID игры существует",
  gameIdNotExists: "ID игры не существует",
  parentProviderInactive: "Родительский провайдер неактивен",
  betLimitNotExists: "Лимит ставки не существует",
  min3Characters: "Минимум 3 символа",
  invalidBankAccType: "Недействительный тип банковского счета",
  senderBankNotExists: "Банк отправителя не существует",
  recipientBankNotExists: "Банк получателя не существует",
  affiliateNotExists: "Агент не существует",
  redepositedTicket: "Тикет повторного депозита",
  invalidDepositType: "Недействительный тип депозита",
  affiliateInactive: "Агент неактивен",
  bonusUnavailable: "Бонус недоступен",
  pendingDeposit: "Ожидающий депозит ",
  noOngoingPromotion: "Нет действующих промоакций",
  iframeNotExists: "Iframe не существует",
  gameMaintenance: "Техническое обслуживание игры",
  labelInactive: "Ярлык неактивен",
  invalidDomainType: "Недействительный тип домена",
  invalidModule: "Недействительный модуль",
  labelFull: "Ярлык заполнен",
  questionExists: "Вопрос существует",
  questionFull: "Вопрос заполнен",
  questionNotExists: "Вопрос не существует",
  reviewNotExists: "Отзыв не существует",
  invalidDomainGroup: "Недействительный группа доменов",
  invalidDateRange: "Недействительный диапазон дат ",
  ipAddressNotExists: "IP адрес не существует",
  marqueeNotExists: "Бегущая строка не существует",
  invalidAmount: "Недействительный сумма",
  insufficientBalance: "Недостаточный баланс",
  minLimitLtParent: "Минимальный баланс меньше родительского",
  maxLimitGtParent: "Максимальный лимит больше родительского",
  startDateGtEndDate: "Дата начала больше даты конца",
  currencyNotExists: "Валюта не существует",
  currencyExists: "Валюта существует",
  noAccumulateWin: "нет накопленного выигрыша",
  invalidSession: "Недействительная сессия",
  sessionExpired: "Сессия истекла",
  promotionExists: "Промоакция существует",
  invalidCriteria: "Недействительные параметры",
  promotionNotExists: "промоакция не существует",
  ticketNotExists: "Тикет не существует",
  duplicateDebitRecord: "Дубликат записи дебета",
  duplicateCreditRecord: "Дубликат записи кредита",
  debitRecordNotExists: "Запись дебита не существует",
  minDepositNotMet: "Минимальный депозит не соотвествует",
  duplicateBet: "Дубликат ставки",
  invalidProviderCode: "Недействительный код провайдера",
  resultExists: "Результат существует",
  unableSPProcess: "Система не может обработать ваш запрос",
  authRequired: "Требуется код аутентификации",
  domainExists: "Домен уже существует",
  multiSelectOption: "Пожалуйста, выберите {fname}",
  invalidDomainFormat: "Недействительный формат домена",
  noHttpHttps: "'https://' или 'http://' недопустимы",
  noReservedSubdomain: "Зарезервированный суб-домен не допускается. Для использования ссылки загрузите приложение",
  operatorInactive: "Оператор неактивен",
  invalidAccountIdFormat: "Недействительный формат ID аккаунта",
  contentIdRequired: "Требуется ID меню",
  themeCodeRequired: "Требуется код темы",
  themeNameRequired: "Требуется название темы",
  themeColorRequired: "Требуется цвет темы",
  languageRequired: "Требуется язык",
  positionRequired: "Требуется позиция",
  themeContentIdRequired: "Требуется ID темы контента",
  emailRequired: "Требуется email",
  themeProviderTypeRequired: "Требуется тип темы провайдера",
  phoneRequired: "Требуется телефон",
  targetTypeRequired: "Требуется тип цели",
  packageTypeRequired: "Требуется тип пакет",
  renewTermRequired: "Требуется обновить правило",
  packagePriceRequired: "Требуется стоимость пакета",
  packageStatusRequired: "Требуется статус пакета",
  sortKeyRequired: "Требуется ключ сортировки",
  invalidDomainStatus: "недействительный статус домена",
  invalidCurrency: "недействительный валюта",
  invalidThemeCode: "недействительный код темы",
  invalidLanguage: "недействительный язык",
  invalidPosition: "недействительный позиция",
  invalidThemeContent: "недействительный контент темы",
  allParamsSameAsCurrent: "Без изменений",
  invalidThemeColor: "недействительный цвет темы",
  invalidCartStatus: "недействительный статус корзины",
  invalidThemeProviderType: "недействительный тип темы провайдера",
  themeProviderTypeCannotBeUse: "Тема провайдера не может  быть использована",
  invalidUserStatus: "недействительный статус пользователя",
  packageCannotBeRemove: "Пакет не может быть удален",
  userStatusIsAlrdSuspend: "Пользователь уже приостановлен",
  userStatusIsAlrdBlocked: "Пользователь уже заблокирован",
  userStatusIsAlrdActive: "Пользователь уже активный",
  invalidSortType: "недействительный тип корзины",
  startDateBiggerThanEndDate: "Дата начала больше даты окончания",
  positionCannotBeUse: "Позиция не может быть использована",
  funcAddContentFailed: "Не удалось добавить контент",
  funcDeleteContentFailed: "Не удалось удалить контент",
  funcUpdateContentFailed: "Не удалось обновить контент",
  funcAddThemeFailed: "Не удалось добавить тему",
  funcDeleteThemeFailed: "Не удалось удалить тему",
  funcUpdateThemeFailed: "Не удалось обновить тему",
  funcAddThemeColorFailed: "Не удалось добавить цвет темы",
  funcDeleteThemeColorFailed: "Не удалось удалить цвет темы",
  funcUpdateThemeColorFailed: "Не удалось обновить цвет темы",
  funcAddLanguageFailed: "Не удалось добавить язык",
  funcDeleteLanguageFailed: "Не удалось удалить язык",
  funcUpdateLanguageFailed: "Не удалось обновить язык",
  funcAddThemeContentFailed: "Не удалось добавить тему контента",
  funcDeleteThemeContentFailed: "Не удалось удалить тему контента",
  funcUpdateThemeContentFailed: "Не удалось обновить тему контента",
  funcAddContentPositionFailed: "Не удалось добавить позицию контента",
  funcUpdateContentPositionFailed: "Не удалось удалить позицию контента",
  funcDeleteContentPositionFailed: "Не удалось обновить позицию контента",
  funcAddThemeProviderTypeFailed: "Не удалось добавить тип темы провайдера",
  funcUpdateThemeProviderTypeFailed: "Не удалось обновить тип темы провайдера",
  funcDeleteThemeProviderTypeFailed: "Не удалось удалить тип темы провайдера",
  funcAddPackageFailed: "Не удалось добавить пакет",
  funcUpdatePackageFailed: "Не удалось обновить пакет",
  funcDeletePackageFailed: "Не удалось удалить пакет",
  nicknameRequired: "Требуется никнейм",
  accountStatusRequired: "Требуется статус аккаунта",
  contentIdMaxLength50: "Максимальная длина ID меню 50",
  positionMaxLength10: "Максимальная длина позиции 10",
  contentDescMaxLength200: "Максимальная длина описания контента 200",
  domainStatusRequired: "требуется статус домена",
  funcAddDomainFailed: "не удалось добавить домен",
  funcUpdateDomainFailed: "Не удалось обновить домен",
  uploadFailed: "Загрузка не удалась",
  sortKeyMaxLength50: "Макс длина ключа корзины 50",
  invalidSortTypeFormat: "Недействительный формат типа корзины",
  invalidPackageId: "Недействительный ID пакета",
  invalidAccountStatusFormat: "Недействительный формат статуса аккаунта",
  invalidSiteStatusFormat: "Недействительный формат статуса сайта",
  invalidPackageStatus: "Недействительный статус сайта",
  invalidEmailFormat: "Недействительный формат email",
  invalidPhoneFormat: "Недействительный формат телефона",
  languageLengthNotInRange: "Длина языка не в диапазоне (2-5)",
  languageDescriptionMaxLength50: "макс длина описания языка 50",
  remarkMaxLength500: "макс длина комментария 500",
  themeProviderTypeMaxLength50: "макс длина типа темы провайдера 50",
  themeNameMaxLength50: "макс длина названия темы 50",
  themeColorMaxLength20: "Макс длина названия цвета 20",
  noSpace: "Обязательно без пробелов",
  packageDescEnRequired: "Требуется название на английском",
  packageDescEnMaxLength20: "макс длина названия на англ 20",
  allParamsIsNull: "Все параметры являются нулевыми",
  contentCannotBeRemove: "Контент нельзя удалить ",
  contentDetailsRequired: "Требуются детали контента",
  domainCannotBeUse: "Домен нельзя использовать",
  domainGroupMaxLength20: "Макс длина группы доменов 20",
  domainGroupRequired: "Требуется группа доменов",
  domainNameCannotUpdate: "Нельзя обновить имя домена",
  domainNameMaxLength400: "Макс длина имени домена 400",
  domainsRequired: "Требуются домены",
  domainStatusMaxLength20: "Макс длина статуса домена 20",
  domainTypeMaxLength10: "Макс длина типа домена 10",
  funcAddThemeContentGroupFailed: "Не удалось добавить группу темы контента",
  funcDeleteThemeContentGroupFailed: "Не удалось  удалить группу темы контента",
  funcOpsiteUpdateFailed: "не удалось обновить противоположный сайт",
  funcResetAccountPasswordFailed: "Не удалось сбросить пароль аккаунта",
  funcSiteLanguageUpsertFailed: "Не удалось обновить язык сайта",
  funcSiteThemeContentUpsertFailed: "Не удалось обновить тему контента сайта",
  funcSiteThemeUpsertFailed: "Не удалось обновить тему сайта",
  funcSiteUpdateFailed: "Не удалось обновить сайт",
  funcUpdateAccountFailed: "Не удалось обновить аккаунт",
  funcUpdateAccountStatusActiveFailed: "Не удалось обновить статус аккаунта на активный",
  funcUpdateAccountStatusCompanyBlockFailed: "Не удалось обновить статус аккаунта до блокировки компании",
  funcUpdateAccountStatusSuspendFailed: "Не удалось обновить статус аккаунта до приостановки",
  funcUpdateThemeContentGroupFailed: "Не удалось обновить группу темы контента",
  invalidBoDomain: "Недействительный домен ВО",
  invalidOperatorIdFormat: "Недействительный формат ID оператора",
  invalidOpsite: "Недействительный противоположный сайт",
  invalidOpsiteOperator: "Недействительный оператор противоположного сайта",
  invalidOpsiteVersion: "Недействительный версия противоположного сайта",
  invalidParentContentInGroup: "Недействительный родительский контент в группе",
  invalidSite: "Недействительный сайт",
  invalidSiteStatus: "Недействительный статус сайта",
  invalidThemeContentGroup: "Недействительная группа темы контента",
  languageCannotBeUse: "язык не может быть использован",
  languagesRequired: "Требуется язык",
  logo1Required: "Требуется логотип",
  notSupportMultiDefault: "Мульти-дефолт не поддерживается",
  operatorIdMaxLength50: "макс длина ID оператора 50",
  opsiteNotMatch: "Противоположный сайт не совпадает",
  packageTypeMaxLength15: "Макс длина типа пакета 15",
  parentContentIdCannotSameWithContentId: "ID родительского контента не может совпадать с ID контента",
  phoneNumberRequired: "Требуется номер телефона",
  siteIdRequired: "Требуется ID сайта",
  siteNameMaxLength50: "Макс длина названия сайта 50",
  siteNameRequired: "Требуется название сайта",
  technicalError: "Техническая ошибка",
  themeCannotBeRemove: "тему нельзя удалить",
  themeCodeCannotBeUse: "Нельзя использовать код темы",
  themeCodeMaxLength20: "макс длина кода темы 20",
  themeColorCannotBeRemove: "Нельзя удалить цвет темы",
  themeColorCannotBeUse: "Нельзя использовать цвет темы",
  themeContentCannotBeUse: "Нельзя использовать тему контента",
  themeContentGroupCannotBeUse: "Нельзя использовать группу темы контента",
  themeContentGroupDescriptionMaxLength50: "Макс длина описания группы темы контента 50",
  themeContentGroupMaxLength20: "Макс длина группы темы контента 20",
  themeContentGroupRequired: "Требуется группа темы контента",
  themeNameCannotBeUse: "Нельзя использовать название темы",
  userHaventVerifyThisBefore: "Пользователь не подтверждал это ранее",
  isDefaultTrueRequired: "Язык должен быть 1 по умолчанию",
  accountIdMaxLength50: "Макс длина ID пользователя 50",
  headBodyScriptEitherOne: "Пожалуйста, введите Head Script или Body Script",
  alphaOrNum: "Только буквы или цифры",
  phoneValid: "Пожалуйста, введите действительный номер телефона",
  permittedAmountRequired: "Требуется допустимая сумма",
  ignoreRiskRequired: "Требуется проигнорировать риск",
  paymentDescRequired: "Требуется описание платежа",
  gameTypeRequired: "Требуется тип игры",
  statusRequired: "Требуется статус",
  payoutIdRequired: "Требуется ID выплаты",
  commNotExists: "Комиссия не существует",
  parentCommNotExists: "Родительская комиссия не существует",
  carryOverNotExists: "перенос не существует",
  hotGameExists: "Горячая игра уже существует",
  commSportsExceededParent: "Комиссия на спорт превышает родительскую",
  commSlotsExceededParent: "Комиссия на слоты превышает родительскую",
  commLivecasinoExceededParent: "Комиссия на live казино превышает родительскую",
  commCockfightExceededParent: "Комиссия на петушиные бои превышает родительскую",
  commOthersExceededParent: "Комиссия на другое превышает родительскую",
  hotGameNotExists: "Горячая игра не существует",
  noSecurityDeposit: "нет фонда спасения",
  exchangeRateNotExists: "курс обмена не существует",
  insufficientSecurityDeposit: "Недостаточный фонд спасения",
  duplicateDomain: "Дубликат домена",
  contactEmailNotExists: "Контактный email не существует",
  featuredGameNotExists: "Рекомендованная игра не существует",
  newGameNotExists: "Новая игра не существует",
  popularGameNotExists: "Популярная игра не существует",
  featuredGameExists: "рекомендованная игра уже существует",
  newGameExists: "Новая игра уже существует",
  popularGameExists: "Популярная игра уже существует",
  rebateNotExists: "Скидка не существует",
  riskyMember: "Рискованный участник",
  ipRestricted: "IP-адрес ограничен",
  notSupportedBank: "Не поддерживаемый банк",
  requestTooFrequent: "Слишком частный запрос",
  paymentOptionNotExists: "Платежный метод не существует",
  earningIdRequired: "Требуется ID заработка",
  ptOnRequired: "Требуется включить PT",
  ptRequired: "Требуется РТ",
  userIdRequired: "Требуется ID  пользователя",
  businessIdRequired: "Требуется ID бизнесса",
  subAccountIdRequired: "Требуется ID суб-аккаунта",
  sourceAccountIdRequired: "Требуется ID источника аккаунта",
  targetAccountIdRequired: "Требуется ID целевого аккаунта",
  ticketTaken: "Тикет принят",
  ticketNotTaken: "Тикет не принят",
  invalidPt: "Недействительный РТ",
  topupIdRequired: "Требуется id пополнения",
  promotionMemberLogNotExists: "Журнал участников промоакции не существует",
  paymentOptionInactive: "Платежный метод неактивен",
  invalidCartStatusFormat: "Недействительный формат статуса корзины",
  requestIncompleted: "Запрос не выполнен",
  unknownError: "Произошла неизвестная ошибка",
  cartIdRequired: "Требуется ID корзины",
  stepNameRequired: "Требуется название шага",
  invalidCart: "Недействительная корзина",
  invalidStepName: "Недействительное название шага",
  cartHaventSetupComplete: "Настройка корзины не завершена",
  funcCartCreateFailed: "не удалось создать корзина",
  funcCartUpdateFailed: "не удалось обновить корзину",
  funcSiteCreateFailed: "Не удалось создать сайт",
  funcCartPurchasedUpdateFailed: "Не удалось обновить купленную корзину",
  invalidPasswordFormat: "Недействительный формат пароля",
  currencyCodeRequired: "Требуется валюта",
  funcCartLanguageUpsertFailed: "Не удалось обновить функцию языка корзины",
  invalidUserIdFormat: "Недействительный формат ID пользователя",
  operatorPasswordRequired: "Требуется пароль оператора",
  funcCartOperatorInfoUpsertFailed: "не удалось обновить функцию оператора корзины",
  invalidOperatorPasswordFormat: "Недействительный формат пароля оператора",
  operatorIdCannotBeUse: "Нельзя использовать ID оператора",
  siteNameLengthNotInRange: "Длина названия сайта не соответствует допустимому диапазону",
  userIdCannotBeUse: "Нельзя использовать ID пользователя",
  siteIdAlrdExist: "ID сайта уже существует",
  operatorIdAlrdExist: "ID оператора уже существует",
  externalIdAlrdExist: "Внешний ID уже существует",
  opsiteContentAlrdExist: "Контент сайт, тема контента уже существуют",
  opsiteLanguageAlrdExist: "Языка контента сайта уже существует",
  boAccountAlrdExist: "Аккаунт ВО уже существует",
  boAccountProfileAlrdExist: "Профиль акккаунта ВО уже существует",
  boAccountLoginAlrdExist: "логин аккаунта ВО уже существует",
  funcCartThemeCodeUpsertFailed: "Не удалось обновить тему корзины",
  funcCartThemeColorUpsertFailed: "не удалось обновить цвет корзины",
  funcOpsiteCreateFailed: "не удалось создать контент сайта",
  alphabetValid: "Должно быть хотя бы одна заглавная и одна строчная буква",
  numberValid: "Должно быть хотя бы одна цифра",
  symbolValid: "Должно быть хотя бы один символ",
  credentialNotSet: "Учётные данные не заданы",
  validBankAccFormat: "Неверный формат номера банковского счёта",
  moreThan: "{fname} должно быть меньше или равно {fname2}",
  lessThan: "{fname} должно быть больше или равно {fname2}",
  bankAccountNotAvailable: "Банковский счёт недоступен",
  insufficientCredit: "Недостаточно средств на счёте",
  enableRequired: "Требуется включение",
  funcAddGameFailed: "Не удалось добавить игру",
  funcAddGameRewardByBatchFailed: "Не удалось добавить игровую награду пакетом",
  funcAddGameRewardFailed: "Не удалось добавить игровую награду",
  funcAddGameTemplateFailed: "Не удалось добавить шаблон игровой награды",
  funcAddLayoutTemplateFailed: "Не удалось добавить шаблон макета",
  funcAddOperatorGameFailed: "Не удалось добавить оператора игры",
  funcAddOperatorMemberWalletFailed: "Не удалось добавить кошелёк участника оператора",
  funcDeleteGameFailed: "Не удалось удалить игру",
  funcDeleteGameRewardFailed: "Не удалось удалить награду за игру",
  funcDeleteGameTemplateFailed: "Не удалось удалить шаблон игры",
  funcDeleteLayoutTemplateFailed: "Не удалось удалить шаблон макета",
  funcDeleteOperatorGameFailed: "Не удалось удалить оператора игры",
  funcUpdateGameFailed: "Не удалось обновить игру",
  funcUpdateGameRewardFailed: "Не удалось обновить награду за игру",
  funcUpdateGameTemplateFailed: "Не удалось обновить шаблон игры",
  funcUpdateLayoutTemplateFailed: "Не удалось обновить шаблон макета",
  funcUpdateOperatorGameFailed: "Не удалось обновить оператора игры",
  gameCannotBeRemove: "Игра не может быть удалена",
  gameNameCannotBeUse: "Название игры не может быть использовано",
  gameNameMaxLength150: "Название игры должно быть не более 150 символов",
  gameRewardCannotBeUse: "Награда за игру не может быть использована",
  gameRewardLimitExceeded: "Лимит награды за игру превышен",
  gameTemplateExist: "Шаблон игры уже существует",
  gameTypeMaxLength20: "Тип игры должен быть не более 20 символов.",
  invalidGame: "Недействительная игра",
  invalidGameReward: "Недействительная награда за игру",
  invalidGameTemplate: "Недействительный шаблон игры",
  invalidMemberWallet: "Недействительный кошелек участника",
  invalidOperatorGame: "Недействительный кошелек участника",
  invalidRewardProbability: "Недействительный оператор игры",
  invalidTemplate: "Недействительный шаблон игры",
  maxGameRewardRequired: "Требуется максимальная награда за игру",
  maxMiniGameRewardRequired: "Требуется максимальная награда за мини-игру",
  memberWalletAlrdExist: "Кошелёк участника уже существует",
  operatorGameCannotBeUse: "оператор игры не может быть использован",
  operatorGameIdRequired: "Требуется ID оператора игры",
  rewardCodeMaxLength20: "Код награды должен содержать не более 20 символов",
  rewardCodeRequired: "Требуется код награды",
  rewardCurrencyMaxLength5: "Валюта награды должна содержать не более 5 символов",
  rewardCurrencyRequired: "Требуется валюта награды",
  rewardDescriptionMaxLength100: "Описание награды должно содержать не более 100 символов",
  rewardNameMaxLength50: "Название награды должно содержать не более 50 символов",
  rewardProbabilityRequired: "Требуется указать вероятность получения награды",
  rewardRequired: "Требуется награда",
  selectedTemplateMaxLength30: "Выбранный шаблон должен содержать не более 30 символов",
  selectedTemplateRequired: "Требуется выбранный шаблон",
  success: "Успех",
  templateCannotBeRemove: "Шаблон не может быть удалён",
  templateCodeCannotBeUse: "Код шаблона не может быть использован",
  templateCodeMaxLength30: "Код шаблона должен содержать не более 30 символов",
  templateCodeRequired: "Требуется код шаблона",
  templateNameMaxLength50: "Название шаблона должно содержать не более 50 символов",
  tokenRequestRequired: "Требуется запрос токена",
  tokenRequired: "Требуется токен",
  mustMoreThan: "{fname} должен быть больше {fvalue}",
  mustMoreThanOrEqual: "{fname} должен быть больше или равен {fvalue}",
  tokenInvalid: "Недействительный ввод токена по адресу {key}",
  cashInvalid: "Недействительный ввод наличных по адресу {key}",
  atLeastOneRequired: "Требуется хотя бы один",
  cash1To7Required: "Требуются наличные от 1 до 7",
  cash1To6Required: "Требуются наличные от 1 до 6",
  cash1To5Required: "Требуются наличные от 1 до 5",
  cash1To4Required: "Требуются наличные от 1 до 4",
  cash1To3Required: "Требуются наличные от 1 до 3",
  cash1To2Required: "Требуются наличные от 1 до 2",
  cash1Required: "Требуются наличные 1",
  token1To7Required: "Требуются токены от 1 до 7",
  token1To6Required: "Требуются токены от 1 до 6",
  token1To5Required: "Требуются токены от 1 до 5",
  token1To4Required: "Требуются токены от 1 до 4",
  token1To3Required: "Требуются токены от 1 до 3",
  token1To2Required: "Требуются токены от 1 до 2",
  token1Required: "Требуются токены 1 ",
  cycleRequired: "Требуется цикл",
  targetAmountRequired: "Требуется целевая сумма",
  gamifyIdRequired: "требуется ID награды",
  gamifyMemberProcessed: "Награда участника обработана",
  gamifyNotExists: "Награда не существует",
  gamifyInactive: "Награда неактивна",
  invalidCycle: "Неверный цикл",
  memberIdMaxLength50: "ID участника не должен превышать 50 символов",
  funcAddGameWalletFreeCreditFailed: "Не удалось добавить бесплатный кредит на игровой кошелёк",
  funcUpdateOperatorMemberWalletBalanceFailed: "Не удалось обновить баланс кошелька оператора",
  funcUpdateOperatorMemberWalletBalanceByFrozenFailed: "Не удалось обновить баланс кошелька оператора на замороженную сумму",
  mustHaveBothAlphaNumOnly: "Используйте только буквы и цифры как минимум по одному символу каждого типа",
  setupGameRewardBeforeEnable: "Пожалуйста, настройте награду за игру перед её включением",
  rewardProbabilityMustNotAllZero: "Вероятности получения награды не должны быть равны нулю",
  totalRewardProbabilityCannotOver100: "Общая вероятность получения награды не может превышать 100",
  credential1To2Required: "Требуются учётные данные от 1 до 2",
  credential1To4Required: "Требуются учётные данные от 1 до 4",
  newRemarkRequired: "Требуется комментарий",
  notSupportedWithdrawalPG: "Неподдерживаемый платежный сервис для вывода средств",
  prizeInvalid: "Неверное значение приза в {key}",
  exceedMaxCampaignCount: "Превышено максимальное количество кампаний в таблице лидеров.",
  leaderboardCampaignEnded: "Кампания в таблице лидеров завершена.",
  leaderboardCampaignStarted: "Кампания таблицы лидеров начата",
  leaderboardCampaignSettled: "Кампания таблицы лидеров завершена",
  pleaseSelectUpToNoPhone: "Пожалуйста, выберите до {fname} номера(ов) телефона.",
  phoneNotAvailable: "Телефон недоступен.",
  batchExpired: "Партия просрочена.",
  remarkNotSame: "Примечание не совпадает",
  partnerIdRequired: "Требуется ID партнёра",
  partnerNotExists: "Партнёр не существует",
  urgencyRequired: "Требуется срочность",
  groupSizeRequired: "Требуется размер группы",
  inactiveDaysRequired: "Требуются неактивные дни",
  idRequired: "Требуется ID",
  expiryRequired: "Требуется дата истечения срока",
  batchIdRequired: "Требуется ID партии",
  requestDateRequired: "Требуется дата запроса",
  requestByRequired: "Требуется заявитель",
  cpiIdRequired: "Требуется CPI ID",
  assigneeRequired: "Требуется назначенный",
  phoneNotAvailable: "Телефон недоступен",
  liveChatNotExists: "Чат не существует",
  resultNotExists: "Результат не существует",
  lastLaunchFundTransfer: "Последний перевод средств запуска",
  alreadyRegistered: "Уже зарегистрирован",
  invalidId: "Неверный ID",
  batchExpired: "Партия истекла",
  teleCalling: "Телефонные звонки",
  invalidUrgency: "Неверная срочность",
  appTypeRequired: "Требуется тип приложения",
  invalidAppType: "Неверный тип приложения",
  appLinkRequired: "Требуется ссылка на приложение",
  invalidDomain: "Неверный домен",
  existEndDateGtEndDate: "Существующая дата окончания позже новой даты окончания",
  newRemark2Required: "Требуется новое примечание 2",
  remark2NotSame: "Примечание 2 не совпадает",
  remark2Required: "Требуется примечание 2",
  nameRequired: "Требуется имя",
  aiAssistantNotExists: "AI Ассистент не существует",
  aiAssistantInactive: "AI Ассистент неактивен",
  phoneStartWithVND: "Номер телефона должен начинаться с 84",
  otherActiveLiveChat: "Есть другой активный LiveChat",
  whiteLabelRequired: "Требуется White Label",
  invalidWhiteLabel: "Недействительный White Label",
  baseRateDepositRequired: "Требуется базовая ставка депозита",
  revisionRequired: "Требуется ревизия",
  typeDescRequired: "Требуется описание типа",
  riskWeightRequired: "Требуется вес риска",
  linkageTypeRequired: "Требуется тип связки",
  valueRequired: "Требуется значение",
  baseRateWithdrawalRequired: "Требуется базовая ставка вывода",
  sourceIdRequired: "Требуется ID источника",
  targetIdRequired: "Требуется ID получателя",
  linkageTypeNotExists: "Тип связки не существует",
  phoneStartWithMYR: "Номер телефона должен начинаться с 60",
  minWithdrawalAmount100: "Минимальная сумма вывода — 100",
  invalidReward: "Недействительное вознаграждение",
  noRow: "Нет строк",
  credentialRequired: "Требуются учетные данные",
  settlementIdRequired: "Требуется ID расчета",
  settlementDateRequired: "Требуется дата расчета",
  newCryptoAddressRequired: "Требуется новый крипто-адрес",
  cryptoAddressRequired: "Требуется крипто-адрес",
  settlementTypeRequired: "Требуется тип расчета",
  chatProviderRequired: "Требуется провайдер чата",
  countRequired: "Требуется количество",
  voucherCodeRequired: "Требуется код ваучера",
  eventTypeRequired: "Требуется тип события",
  viewTypeRequired: "Требуется тип отображения",
  actionTypeRequired: "Требуется тип действия",
  thresholdRequired: "Требуется порог",
  missionIdRequired: "Требуется ID миссии",
  ruleIdRequired: "Требуется ID правила",
  aggregatorRequired: "Требуется агрегатор",
  rebateIdRequired: "Требуется ID ребейта",
  liveChatExists: "Этот livechat уже существует",
  triggerNotExists: "Триггер не существует",
  missionRuleNotExists: "Правило миссии не существует",
  invalidVoucherCode: "Неверный код ваучера",
  invalidRebateType: "Неверный тип ребейта",
  invalidSettlementType: "Неверный тип расчета",
  missionNotExists: "Миссия не существует",
  settlementTypeNotExists: "Тип расчета не существует",
  parentTriggerInactive: "Родительский триггер неактивен",
  parentMissionInactive: "Родительская миссия неактивна",
  missionRuleNotSet: "Правило миссии не установлено",
  invalidCreditType: "Неверный тип кредита",
  cryptoDisabled: "Крипто отключено",
  depositExists: "Депозит уже существует",
  parentSettlementTypeNotExists: "Родительский тип расчета не существует",
  accessControlNotExists: "Контроль доступа не существует",
  cryptoAccountFull: "Крипто аккаунт заполнен",
  cryptoAccountExists: "Крипто аккаунт уже существует",
  cryptoAccountNotExists: "Крипто аккаунт не существует",
  settlementNotAvailable: "Расчет недоступен",
  settlementProcessed: "Расчет обработан",
  cryptoAccountInactive: "Крипто аккаунт неактивен",
  leadIdRequired: "Требуется ID лида",
  failedToCreateFreeRound: "Не удалось создать бесплатный раунд.",
  failedToGetFreeRound: "Не удалось получить бесплатный раунд.",
  failedToGetFreeRoundGameList: "Не удалось получить список игр бесплатного раунда.",
  tierFull: "Уровень заполнен",
  tierNotExists: "Уровень не существует",
  ticketTypeRequired: "Тип билета обязателен",
  invalidTicketType: "Недопустимый тип билета",
  positionRequired: "Позиция обязательна",
  invalidPosition: "Недопустимая позиция",
  invalidBonusRate: "Недопустимый бонусный процент",
  minRequired: "Минимальное значение обязательно",
  maxRequired: "Максимальное значение обязательно",
  minGtMax: "Минимальное значение больше максимального.",
  sessionExists: "Сессия уже существует",
  sessionOverlaps: "Сессии пересекаются",
  sessionIdRequired: "ID сессии обязателен",
  sessionNotExists: "Сессия не существует",
  nameExists: "Имя уже существует",
  sessionElapsed: "Время сессии истекло",
  validUrl: "Пожалуйста, введите корректный URL",
  minBalanceNotMet: "Минимальный баланс не достигнут",
  validSlugFormat: "Недопустимый формат слага",

  failedToCancelFreeRound: "Не удалось отменить бесплатный раунд.",
  failedToGetFreeRoundLineBet: "Не удалось получить линейную ставку бесплатного раунда.",
};